var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SideBar'),_c('v-main',[(_vm.$store.getters.getRoleError)?_c('v-alert',{attrs:{"type":"error","prominent":"","text":""}},[_vm._v(" Your current role doesn't allow you to view this page. ")]):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }